<div class="resource-drop-slot" [class.empty]="isEmpty" [class.filled]="!isEmpty" [class.drag-over-slot]="isDragOver">
  <div *ngIf="isEmpty" class="content-container">
    <span class="empty-text">Drop resource</span>
  </div>
  
  <div *ngIf="!isEmpty" class="resource-content content-container">
    <div *ngIf="!isBiosampleLibraryPrep" class="resource-info">
      <span class="resource-name" [title]="resource?.name">{{ resource?.name }}</span>
    </div>

    <div *ngIf="isBiosampleLibraryPrep" class="resource-info">
      <span class="resource-name" [title]="biosampleName">{{ biosampleName }}</span>
      <span class="resource-name" [title]="libraryPrepName">{{ libraryPrepName }}</span>
    </div>
    

    <rad-icon-button
      (click)="removeResource($event)"
      class="rad-theme--light remove-button"
      icon-name="close"
      [title]="'Remove ' + resource?.name">
    </rad-icon-button>
  </div>
</div>
